import {isRejectedWithValue} from "@reduxjs/toolkit";
import type {Middleware} from "@reduxjs/toolkit";
import {setForbidden} from "../features/auth/forbiddenSlice";

/**
 * Middleware to detect 403 Forbidden errors from API responses
 * and set the forbidden state.
 */
export const forbiddenMiddleware: Middleware = (api) => (next) => (action) => {
    // Check if the action is a rejected API call
    if (isRejectedWithValue(action)) {
        // Check if the rejection payload has a status of 403
        // RTK Query puts the error payload in `action.payload`.
        // The structure might depend slightly on your error handling setup,
        // but `status` is common for fetchBaseQuery errors.
        // Also check action.payload exists and is an object before accessing status
        if (
            action.payload &&
            typeof action.payload === "object" &&
            "status" in action.payload &&
            action.payload.status === 403
        ) {
            console.warn(
                "Received 403 Forbidden response. Setting forbidden state."
            );
            api.dispatch(setForbidden());
        }
    }

    return next(action);
};
